import { debug } from './logging'

/**
 * It remmoves Non-Patient or Current Patient and/or New Patient
 * @param tags string[] | undefined
 * @returns tags
 */
export function removePatientType(tags: string[] | undefined) {
  if (!tags) return []
  debug(`tags`, `with patient tyep`, tags)
  let filteredTags = [...tags]
  const nonPatientIndex = tags.findIndex((tag) => tag === `Non-Patient`)
  if (nonPatientIndex !== -1) {
    filteredTags.splice(nonPatientIndex, 1)
    return filteredTags
  }
  const currentPatientIndex = filteredTags.findIndex((tag) => tag === `Current Patient`)
  if (currentPatientIndex !== -1) {
    filteredTags.splice(currentPatientIndex, 1)
  }
  const newPatientIndex = filteredTags.findIndex((tag) => tag === `New Patient`)
  if (newPatientIndex !== -1) {
    filteredTags.splice(newPatientIndex, 1)
  }
  return filteredTags
}
